import { motion } from "framer-motion";
import { COURSE_SEATS } from "./kursusConstants";

const ITEMS = [
  { n: "01", label: "YURAN", value: "HUBUNGI URUSETIA" },
  { n: "02", label: "PESERTA", value: `${COURSE_SEATS} ORANG SAHAJA` },
];

export function CourseInfoGrid() {
  return (
    <section id="butiran" data-testid="kursus-info-grid" className="bg-kursus-bg py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-anton uppercase text-3xl sm:text-4xl text-kursus-white text-center mb-12"
        >
          BUTIRAN <span className="text-kursus-gold">KURSUS</span>
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 max-w-2xl mx-auto">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`kursus-info-card-${item.n}`}
              className="relative bg-kursus-card border border-kursus-border rounded-lg p-5 sm:p-6 hover:-translate-y-1.5 hover:border-kursus-gold/70 transition-all duration-300"
            >
              <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-kursus-red" />
              <p className="font-anton text-3xl sm:text-4xl text-kursus-gold/70 mb-3">{item.n}</p>
              <p className="font-oswald text-xs sm:text-sm tracking-[0.2em] text-kursus-muted mb-1.5">{item.label}</p>
              <p className="font-oswald text-sm sm:text-lg font-semibold text-kursus-white whitespace-pre-line leading-snug">{item.value}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
